"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NewbuildingCard = require("./NewbuildingCard");
Object.keys(_NewbuildingCard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewbuildingCard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewbuildingCard[key];
    }
  });
});